import { getLocale } from "@utils/configuration/aem";
import { formatPriceNoRounding } from "@utils/productPrice";

import { TypedAnalyticsEvent } from "@services/tracking/types/analyticsEvent";
import { CartProductTrackingInfo } from "@services/tracking/types/trackingInfo/cartProductTrackingInfo";
import { CheckoutToolStepTrackingInfo } from "@services/tracking/types/trackingInfo/toolStepTrackingInfo";

const getBazaarVoiceCheckoutTracker = () => {
    return window.BV;
};

const processBazaarVoiceOrderConfirmation = (
    data: TypedAnalyticsEvent<CheckoutToolStepTrackingInfo>,
): void => {
    if (
        data.payload?.eventData?.name === "checkout" &&
        data.payload?.eventData?.stepName === "order confirmation"
    ) {
        const items = (data.payload?.eventData?.cart?.items || []).map(
            (item: CartProductTrackingInfo) => {
                return {
                    price: item.unitPrice.toFixed(2),
                    quantity: item.quantity.toFixed(0),
                    name: item.name,
                    productId: item.id,
                };
            },
        );

        const tracker = getBazaarVoiceCheckoutTracker();
        tracker?.pixel?.trackTransaction({
            orderId: data.payload?.eventData?.cart?.orderId,
            currency: "EUR",
            items,
            shipping:
                data.payload?.eventData?.cart?.deliveryCost?.toFixed(2) ||
                "0.00",
            discount: formatPriceNoRounding(
                data.payload?.eventData?.cart?.globalDiscounts || 0,
                2,
            ),
            email: data.payload?.eventData?.cart?.email,
            locale: getLocale(),
            nickname: data.payload?.eventData?.cart?.name,
            total:
                data.payload?.eventData?.cart?.totalPrice.toFixed(2) || "0.00",
        });

        return;
    }
};

export { processBazaarVoiceOrderConfirmation };
